export default {"src":"/_next/static/media/token.f0a58e61.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};